"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonFormIconSelect = void 0;
const React = require("react");
const form_validations_type_1 = require("../../../utils/validations/form-validations.type");
const icons_names_const_1 = require("../../../utils/constants/icons-names.const");
const form_utils_1 = require("../../../utils/form.utils");
const BronsonFormIconSelect = (props) => {
    const [selectedIcon, setSelectedIcon] = React.useState(props.selectedIcon);
    const validations = [];
    if (props.required) {
        validations.push(form_validations_type_1.BronsonFormValidationsEnum.required);
    }
    React.useEffect(() => {
        setSelectedIcon(props.selectedIcon);
    }, [props.selectedIcon]);
    const setIconButtons = () => {
        const listIcons = [];
        icons_names_const_1.iconList.forEach((name) => {
            const icon = (React.createElement("i", { key: name, className: `c-btn__icon c-icon  c-icon--[${name}]`, role: 'img', style: { fontSize: '2.6em' }, "aria-hidden": 'true' }));
            listIcons.push(React.createElement("div", { id: `div-${name}`, key: `div-${name}`, className: 'o-layout__item u-1/12 u-1/6@m u-1/5@s' },
                React.createElement("button", { style: { border: 'none' }, className: `c-btn c-btn--icon-only ${name === selectedIcon ? '' : 'c-btn--secondary'} ${name}`, onClick: props.onClickIcon }, icon)));
        });
        return listIcons;
    };
    return (React.createElement(React.Fragment, null,
        props.label && (0, form_utils_1.renderLabel)(props.label, validations),
        React.createElement("div", { className: '', style: {
                height: '200px',
                backgroundColor: 'white',
                overflow: 'auto',
            } },
            React.createElement("div", { className: 'o-layout u-text-center', id: 'select-icon-select' }, setIconButtons()))));
};
exports.BronsonFormIconSelect = BronsonFormIconSelect;
